'use client'

import { authFetch } from '@/lib/auth/auth-fetch'
import { useMigration } from '@privy-io/alchemy-migration'
import { useEffect, useRef } from 'react'

/** Flips signer_migrated when MigrationProvider finishes a key transfer. */
export function MigrationStatusReporter() {
	const { step } = useMigration()
	const reportedRef = useRef(false)

	useEffect(() => {
		if (step !== 'success' || reportedRef.current) return
		reportedRef.current = true
		authFetch('/api/auth/migration-status', { method: 'POST' }).catch(() => {
			reportedRef.current = false
		})
	}, [step])

	return null
}
